
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { stringStep } from '../../../concepts/commands/CommandWizard';
import { ObjectManager } from '../../../concepts/objects';
import { BoardSetting } from './BoardSetting';

export const boardSettingSet = defineCommand(
    'boardSettingSet',
    'Board Setting: Set',
    (cc, [group, name, value]: [string, string, any]) => {
        if (!group || !name) return;

        const objects = cc.resolve(ObjectManager);

        objects.update(u => {
            u.set('history', 'skip');

            // Create or update board setting.  If we randomly end up with two, we sort by id so the latest one wins.
            const setting =
                objects.find(BoardSetting, x => x.group === group && x.name === name) ??
                u.create(BoardSetting);

            if (!setting.group) setting.group = group;
            if (!setting.name) setting.name = name;
            setting.value = value ?? null;

        });
    },
    [
        stringStep('group', 'Group:'),
        stringStep('name', 'Name:'),
        stringStep('value', 'Value:'),
    ]
);

export const boardSettingClearAll = defineCommand(
    'boardSettingClearAll',
    'Board Setting: Clear All',
    (cc) => {

        const objects = cc.resolve(ObjectManager);
        const all = Array.from(objects.getAll(BoardSetting));

        objects.update(u => {
            u.set('history', 'skip');
            u.deleteAll(all, 'cascade');
        });
    },
);

export const inBoardSettingCommands = () => inCommands(
    boardSettingSet,
    boardSettingClearAll
);

